import { ImageProps } from '../Image/image.types';

export enum HeadshotTypes {
  DEFAULT = 'silo',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  SILO = 'silo',
  SPOTS = 'spots',
  MILB = 'milb',
  SIXTY_SEVEN = '67',
  EIGHTY_THREE = '83',
}

export interface HeadshotProps extends Partial<ImageProps> {
  playerId?: string | number;
  closeUp?: boolean;
  zoomScale?: number;
  type?: HeadshotTypes | string;
}
